<section class="rounded-2xl border border-gray-200 bg-white p-5 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
  <div class="mb-4 flex items-center justify-between gap-3">
    <div>
      <h2 class="text-sm font-semibold text-gray-800 dark:text-white/90">{{ 'vehicles.equipements' | t }}</h2>
      <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
        {{ 'vehicles.lesEquipementsAidentLes' | t }}
      </p>
    </div>
    <button
      type="button"
      (click)="openPicker()"
      class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      {{ 'vehicles.ajouter' | t }}
    </button>
  </div>

  @if (removeError(); as msg) {
    <div class="mb-3 rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-xs text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ msg }}
    </div>
  }

  @if (groupedCurrent().length === 0) {
    <p class="rounded-lg border border-dashed border-gray-200 bg-gray-50 px-4 py-6 text-center text-sm text-gray-500 dark:border-gray-700 dark:bg-white/[0.02] dark:text-gray-400">
      {{ 'vehicles.aucunEquipementRattachePour' | t }} <span class="font-medium text-gray-700 dark:text-gray-300">{{ 'vehicles.ajouter' | t }}</span> {{ 'vehicles.pourEnSelectionner' | t }}
    </p>
  } @else {
    <div class="space-y-4">
      @for (group of groupedCurrent(); track group.category) {
        <div>
          <h3 class="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            {{ group.label | t }}
          </h3>
          <div class="flex flex-wrap gap-2">
            @for (opt of group.options; track opt.id) {
              <span class="inline-flex items-center gap-1.5 rounded-full border border-brand-200 bg-brand-50 py-1 pl-3 pr-1 text-xs font-medium text-brand-700 dark:border-brand-800 dark:bg-brand-500/10 dark:text-brand-400">
                {{ opt.nameFr }}
                <button
                  type="button"
                  (click)="remove(opt)"
                  [disabled]="busyOptionId() === opt.id"
                  [attr.aria-label]="'Retirer ' + opt.nameFr"
                  class="ml-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full text-brand-700 transition hover:bg-brand-100 disabled:cursor-not-allowed disabled:opacity-50 dark:text-brand-400 dark:hover:bg-brand-500/20"
                >
                  @if (busyOptionId() === opt.id) {
                    <svg class="h-3 w-3 animate-spin" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25" />
                      <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                    </svg>
                  } @else {
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                      <path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
                    </svg>
                  }
                </button>
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</section>

<!-- Picker modal -->
<app-modal
  [isOpen]="pickerOpen()"
  (close)="closePicker()"
  className="w-full max-w-2xl rounded-2xl bg-white p-6 dark:bg-gray-dark"
>
  <div class="space-y-5">
    <div>
      <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">{{ 'vehicles.ajouterDesEquipements' | t }}</h3>
      <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
        {{ 'vehicles.selectionneToutCeQui' | t }}
      </p>
    </div>

    <div class="relative">
      <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm10 2-4.35-4.35" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <input
        type="search"
        [formControl]="searchCtrl"
        [placeholder]="'vehicles.rechercherUnEquipement' | t"
        class="block w-full rounded-lg border border-gray-300 bg-white py-2.5 pl-10 pr-3 text-sm text-gray-700 placeholder-gray-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-white/[0.03] dark:text-gray-200"
      />
    </div>

    @if (catalogLoading()) {
      <div class="flex items-center justify-center py-10 text-sm text-gray-500 dark:text-gray-400">
        <svg class="mr-2 h-5 w-5 animate-spin text-brand-500" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25" />
          <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        </svg>
        {{ 'vehicles.chargementDuCatalogue' | t }}
      </div>
    } @else if (catalogError(); as msg) {
      <div class="flex flex-col items-center gap-2 rounded-lg border border-error-200 bg-error-50 px-4 py-6 text-center dark:border-error-800 dark:bg-error-500/10">
        <p class="text-sm text-error-700 dark:text-error-400">{{ msg }}</p>
        <button type="button" (click)="loadCatalog()" class="text-xs font-medium text-brand-600 hover:underline dark:text-brand-400">
          {{ 'vehicles.reessayer' | t }}
        </button>
      </div>
    } @else if (groupedAvailable().length === 0) {
      <p class="rounded-lg border border-dashed border-gray-200 bg-gray-50 px-4 py-8 text-center text-sm text-gray-500 dark:border-gray-700 dark:bg-white/[0.02] dark:text-gray-400">
        {{ (searchTerm() ? 'vehicles.noOptionForSearch' : 'vehicles.noOptionAllAttached') | t }}
      </p>
    } @else {
      <div class="max-h-[50vh] space-y-5 overflow-y-auto pr-1">
        @for (group of groupedAvailable(); track group.category) {
          <div>
            <h4 class="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              {{ group.label | t }}
            </h4>
            <div class="flex flex-wrap gap-2">
              @for (opt of group.options; track opt.id) {
                <button
                  type="button"
                  (click)="toggleSelect(opt)"
                  [class.border-brand-500]="isSelected(opt)"
                  [class.bg-brand-50]="isSelected(opt)"
                  [class.text-brand-700]="isSelected(opt)"
                  [class.dark:bg-brand-500/10]="isSelected(opt)"
                  [class.dark:text-brand-400]="isSelected(opt)"
                  [class.dark:border-brand-700]="isSelected(opt)"
                  class="inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition hover:border-brand-300 hover:bg-brand-50 hover:text-brand-700 dark:border-gray-700 dark:bg-white/[0.03] dark:text-gray-200 dark:hover:bg-brand-500/10 dark:hover:text-brand-400"
                >
                  @if (isSelected(opt)) {
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <path d="m5 12 5 5L20 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  }
                  {{ opt.nameFr }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (pickerError(); as msg) {
      <div class="rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-xs text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
        {{ msg }}
      </div>
    }

    <div class="flex items-center justify-between gap-3 border-t border-gray-200 pt-4 dark:border-gray-800">
      <p class="text-xs text-gray-500 dark:text-gray-400">
        {{ selectedCount() }} {{ 'vehicles.equipement' | t }}{{ selectedCount() > 1 ? 's' : '' }} {{ 'vehicles.selectionne' | t }}{{ selectedCount() > 1 ? 's' : '' }}
      </p>
      <div class="flex gap-2">
        <button
          type="button"
          (click)="closePicker()"
          [disabled]="picking()"
          class="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
        >
          {{ 'vehicles.annuler' | t }}
        </button>
        <button
          type="button"
          (click)="confirmPick()"
          [disabled]="picking() || selectedCount() === 0"
          class="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50"
        >
          @if (picking()) {
            <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-opacity="0.25" />
              <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
            </svg>
            Ajout…
          } @else {
            Ajouter ({{ selectedCount() }})
          }
        </button>
      </div>
    </div>
  </div>
</app-modal>
